import { isPublicLiveChatNotificationDetails } from "@scrile/api-provider/dist/api/LivechatsProvider";
import { Notification } from "@scrile/api-provider/dist/api/NotificationsProvider";
import { $t } from "@/lib/i18nHelpers";
import { getLiveUrl } from "@/lib/urlHelpers";
import router from "@/router";
import { NotificationData } from "@/types";

export default function(notification: Notification): NotificationData | false {
  const user = notification.user;
  if (isPublicLiveChatNotificationDetails(notification.details) && user) {
    return {
      text: $t("{0} started live video", [user?.screenName]),
      position: "top",
      timeout: 7000,
      image: {
        user: user,
      },
      onNotificationClick: () => router.push(getLiveUrl(user)),
    };
  }
  return false;
}
